export enum KeyType {
    albedo = "albedo",
    ledger = "ledger",
    freighter = "freighter",
    plaintextKey = "plaintextKey",
    trezor = "trezor",
  }